import React, { useEffect, useRef } from "react";
import connect from "Shared/connect";
import * as styles from "./base.scss";
import { translate } from "Shared/translate";
import CloseButton from "../CloseButton";
import Accordion from "SiteLayout/RightMenu/Accordion";
import Item from "SiteLayout/RightMenu/Accordion/item";
import MyMenigoMenu from "../MyMenigo";
import SelectionHeader from "../SectionHeader";
import LogOut from "../LogOut";
import Profile from "../Profile";
import Links from "../Links";
import MainCategories from "../MainProductCategories";
import ShortcutButtons from "../../../Cms/Blocks/ShortcutButtonsBlock/ShortcutButtonsBlock";
import HideOnDesktop from "../HideOnDesktop";
import { setRightMenu } from "../action-creators";
import { LARGE } from "Shared/breakpoints";
const RightMenuContainer = (props) => {
    const ref = useRef(null);
    const tabIndex = 3;
    useEffect(() => {
        const listener = (event) => {
            if (ref.current && !ref.current.contains(event.target))
                props.closeRightMenu();
        };
        document.addEventListener("mousedown", listener);
        return () => {
            document.removeEventListener("mousedown", listener);
            document.body.style.removeProperty("overflow-y");
        };
    }, [ref]);
    useEffect(() => {
        if (props.mainMeny.rightMenuIsOpen)
            ref.current.focus();
    }, [props.mainMeny.rightMenuIsOpen]);
    useEffect(() => {
        if (props.mainMeny.rightMenuIsOpen && props.breakPoint < LARGE) {
            document.body.style.overflowY = "hidden";
        }
        else {
            document.body.style.removeProperty("overflow-y");
        }
    }, [, props.mainMeny.rightMenuIsOpen, props.breakPoint]);
    return (!!props.mainMeny &&
        !!props.mainMeny.rightMenuIsOpen && (React.createElement("div", { ref: ref, className: styles.rightMenuContent, tabIndex: -1 },
        React.createElement("div", { className: styles.innerContainer },
            React.createElement(CloseButton, { tabIndex: tabIndex }),
            props.isLoggedIn && React.createElement(Profile, null),
            props.isLoggedIn && (React.createElement(Accordion, null, !props.isSupplierSalesMan && (React.createElement(Item, { label: translate("/SiteLayout/RightMenu/MyMenigo"), tabindex: tabIndex },
                React.createElement(MyMenigoMenu, { tabIndex: tabIndex }))))),
            React.createElement(HideOnDesktop, null,
                React.createElement(SelectionHeader, { text: translate("/SiteLayout/RightMenu/ExploreAssortment") }),
                React.createElement(MainCategories, { tabIndex: tabIndex }),
                !!props.mainMeny.shortcutButtons &&
                    !!(props.mainMeny.shortcutButtons.buttons.length > 0) && (React.createElement(ShortcutButtons, { buttons: props.mainMeny.shortcutButtons.buttons, header: props.mainMeny.shortcutButtons.header, disableTopPadding: props.mainMeny.shortcutButtons.disableTopPadding, passedStyles: styles, tabIndex: tabIndex, backgroundColor: props.mainMeny.shortcutButtons.backgroundColor, headerLevel: props.mainMeny.shortcutButtons.headerLevel, padding: props.mainMeny.shortcutButtons.padding })),
                React.createElement(SelectionHeader, { text: translate("/SiteLayout/RightMenu/More") }),
                React.createElement(Links, { tabIndex: tabIndex }))),
        props.isLoggedIn && (React.createElement(LogOut, { text: translate("/SiteLayout/RightMenu/LogOut"), tabIndex: tabIndex })))));
};
export default connect((state) => ({
    mainMeny: state.mainMenu,
    isLoggedIn: state.currentUser.isLoggedIn,
    breakPoint: state.currentBreakpoint,
    isSupplierSalesMan: state.currentUser.isSupplierSalesman,
}), (dispatch) => ({
    closeRightMenu: () => dispatch(setRightMenu(false)),
}))(RightMenuContainer);
